import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { parallaxOnScroll } from './utils';

type BlurElementProps = {
  position: {
    x: number;
    y: number;
  };
  direction?: 'left' | 'right';
  size: number;
  speed?: number;
};

function BlurElement({ speed = 0.6, position, size, direction = 'left' }: BlurElementProps): JSX.Element {
  const blurRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleParallax() {
      if (blurRef.current) {
        window.addEventListener('scroll', () => {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          parallaxOnScroll({ element: blurRef.current!, speed, direction: 'down' });
        });
      }
    }

    handleParallax();
    return () => {
      handleParallax();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper ref={blurRef}>
      <Blur
        style={{ animationDelay: `${Math.floor(Math.random() * 10) + 1}s` }}
        direction={direction}
        size={size}
        position={position}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  z-index: -1;
  transform: translateY(0);
`;

const Blur = styled.div<BlurElementProps>`
  @keyframes pulseBlurElement {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.7);
    }
    100% {
      transform: scale(1);
    }
  }

  border-radius: ${({ size }) => size}px;
  background: rgba(252, 91, 0, 0.7);
  filter: blur(${({ size }) => (size < 400 ? 80 : 270)}px);
  animation: pulseBlurElement 7s infinite;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  position: absolute;
  z-index: -1;
  top: ${({ position }) => position.y}px;
  left: ${({ position, direction }) => (direction === 'left' ? `${position.x}px` : '')};
  right: ${({ position, direction }) => (direction === 'right' ? `${position.x}px` : '')};
`;

export default BlurElement;
